import { forwardRef, type AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router';

/** Ссылки Astryx внутри приложения идут через React Router (без перезагрузки страницы). */
export const RouterLink = forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement>>(function RouterLink(
  { href = '', ...rest },
  ref,
) {
  const external = /^(https?:|mailto:|tel:|blob:|data:)/.test(href) || rest.target === '_blank' || rest.download !== undefined;
  if (external) return <a ref={ref} href={href} {...rest} />;
  return <Link ref={ref} to={href} {...rest} />;
});
